/**
 * <fk-product-tabs> — collection tabs above a product grid (WAI-ARIA tabs
 * pattern, automatic activation). Each block = one tab + one pre-rendered
 * panel, so all collections are in the DOM (good for SEO, no section
 * re-render needed) and switching tabs just toggles [hidden].
 */
(function () {
  if (customElements.get('fk-product-tabs')) return;

  class FkProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });
    }

    onKeydown(event, tab) {
      var index = this.tabs.indexOf(tab);
      var next = null;

      if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      else if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      else if (event.key === 'Home') next = this.tabs[0];
      else if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      else return;

      event.preventDefault();
      next.focus();
      this.activate(next);
    }

    activate(activeTab) {
      this.tabs.forEach((tab) => {
        var selected = tab === activeTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');

        var panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });

      if (activeTab.scrollIntoView) {
        activeTab.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  customElements.define('fk-product-tabs', FkProductTabs);
})();
